import React from "react";

import Heading from "components/heading";

import HeroSection from "../../hero-section";
import IntegrationsScroller from "../../integrations-scroller/integrations-scroller";

const title = "Make Enerflo Your Own. Integrate Your Favorite Tools.";

const IntegrateSeamlessly = () => (
  <div className="bg-gray-100">
    <HeroSection title={title} className="flex-col space-y-0 md:space-x-0 px-0">
      <HeroSection.Content className="w-full py-6 md:w-2/3 md:py-8 md:text-center">
        <HeroSection.Header>
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description className="text-gray-400">
          Enerflo leads the way with the most 3rd party integrations, giving you the flexibility to keep the CRM, tools
          and/or processes you love. Key dates, information and data are all intelligently synced back through Enerflo,
          ensuring data compatibility and accuracy so you can focus on getting glass on the roof.
        </HeroSection.Description>
      </HeroSection.Content>

      <figure className="w-full">
        <IntegrationsScroller />
      </figure>
    </HeroSection>
  </div>
);

export default IntegrateSeamlessly;
